var _line, _line2, _line3, _line4, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionareCuMecanismCuStocareLinieJos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 80,
    viewBox: "0 0 116 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 57.25,
    y1: 65,
    x2: 57.25,
    y2: 61,
    stroke: "black",
    strokeWidth: 3.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 57.25,
    y1: 80,
    x2: 57.25,
    y2: 68,
    stroke: "black",
    strokeWidth: 3.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 81,
    y1: 38.25,
    x2: 95,
    y2: 38.25,
    stroke: "black",
    strokeWidth: 3.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 102,
    y1: 38.25,
    x2: 116,
    y2: 38.25,
    stroke: "black",
    strokeWidth: 3.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: -1,
    width: 43,
    height: 43,
    transform: "matrix(1 0 0 -1 36 61)",
    stroke: "black",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionareCuMecanismCuStocareLinieJos);
export default __webpack_public_path__ + "static/media/actionare_cu_mecanism_cu_stocare_linie_jos.84c1f381fae694fcdb449bdc93f3e278.svg";
export { ForwardRef as ReactComponent };